export type WeightUnit = 'lb' | 'kg';

type WeightProps = {
    value: number;
    unit?: WeightUnit;
};

function Weight({ value, unit = 'lb' }: WeightProps) {
    const metric = (value * 0.453592).toFixed(2);
    const label = unit === 'kg'
        ? `${metric} kg`
        : `${value.toFixed(2)} lb.`;

    return (
        <span className="text-nowrap">{label}</span>
    );
}

export default Weight;
